export const transNewPipelineEventType = (eventType) => {
  const eventTypeMap = {
    AdvertisementViewedEvent: 'view',
    AdvertisementClickedEvent: 'click',
    AdvertisementWatchedEvent: 'watch',
  }

  return eventTypeMap[eventType] || eventType
}
